import { getDataFromServer } from "../util";

export const getTemplateById = id => getDataFromServer("GET", "template/" + id, null, true);
export const getTemplates = () => getDataFromServer("GET", "template", null, true);
export const createTemplate = formProps => getDataFromServer("POST", "/template", formProps, true);
export const updateTemplate = (id, formProps) => getDataFromServer("PUT", "/template/" + id, formProps, true);
